import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from './supabaseClient'
// O `lerTudo` do projecto: o PostgREST corta nas mil linhas sem avisar, e uma
// alocacao em falta aqui nao da erro — da um lucro errado, que e pior.
import { lerTudo } from './lerTudo'
import { C } from './theme'
import { Target, RefreshCw } from 'lucide-react'

// O OBJECTIVO DE LUCRO B2B, MÊS A MÊS.
//
// O Marco pôs uma meta: 2 000 € limpos por mês no B2B. Esta é a resposta à
// única pergunta que interessa a meio do mês — "quanto falta, e em perfumes?".
//
// A CONTA É A MESMA DO ECRÃ DE LUCRO REAL, e tem de continuar a ser:
//
//   receita = total_sem_iva − desconto_valor        (por encomenda)
//   lucro   = receita − custo da factura do fornecedor
//
// O `desconto_valor` é a parte que se esquece com facilidade, e foi o erro que
// eu próprio cometi a 30/09/2026 ao responder-lhe de cabeça: o desconto dos
// clientes grandes não está no preço da linha, está ao nível da encomenda.
// Sem o abater, a margem aparecia 20% quando é 16,4% — e a meta parecia
// cumprida quando não estava.
//
// A parte interna (Cátia) entra na receita e no custo e anula-se sozinha,
// porque ela compra ao custo. Tirá-la de um lado só dava prejuízos falsos.
//
// SÓ CONTA O QUE JÁ TEM FACTURA DE FORNECEDOR. Uma encomenda vendida mas ainda
// sem factura tem receita e não tem custo; entrar aqui inflacionava o mês e
// desinflacionava o seguinte. É por isso que um mês pode parecer fraco tendo
// sido bom — o que falta está no que ainda não foi facturado, e isso aparece à
// parte, em baixo.

const OBJECTIVO_OMISSAO = 2000

const eur = (n) => Number(n || 0).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
const mesLegivel = (ym) => {
  const [a, m] = ym.split('-')
  return new Date(Number(a), Number(m) - 1, 1).toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })
}

export default function ObjectivoLucro() {
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')
  const [meses, setMeses] = useState([])
  const [custoFixo, setCustoFixo] = useState(0)
  const [objectivo, setObjectivo] = useState(OBJECTIVO_OMISSAO)
  const [porFacturar, setPorFacturar] = useState({ valor: 0, n: 0 })

  const carregar = async () => {
    setLoading(true); setErro('')
    try {
      const [rCompras, rLinks, rEncs, perfis, cfg, movs] = await Promise.all([
        lerTudo(() => supabase.from('compras_fornecedor').select('id, data_fatura, valor_sem_iva, valor_final_sem_iva'), 'id'),
        lerTudo(() => supabase.from('compras_fornecedor_encomendas').select('id, compra_id, encomenda_id, quantidade_alocada, custo_unitario_previsao, custo_unitario_final'), 'id'),
        lerTudo(() => supabase.from('encomendas').select('id, cliente_id, estado, total_sem_iva, desconto_valor'), 'id'),
        supabase.from('perfis').select('id, cliente_interno').then(r => r.data || []),
        supabase.from('config_sistema').select('chave, valor').eq('chave', 'objectivo_lucro_b2b').then(r => r.data || []),
        supabase.from('movimentos_manuais').select('valor, tipo, recorrencia, ate, activo, conta_no_lucro').then(r => r.data || []),
      ])
      // Falhar fechado: com uma leitura incompleta o numero sai errado sem se
      // ver, e este ecra existe para decidir com ele.
      for (const r of [rCompras, rLinks, rEncs]) if (r.error) throw r.error
      const compras = rCompras.data, links = rLinks.data, encs = rEncs.data

      const alvo = Number(cfg[0]?.valor)
      setObjectivo(Number.isFinite(alvo) && alvo > 0 ? alvo : OBJECTIVO_OMISSAO)

      // Custos fixos por mês. O anual divide-se por doze; o pontual não conta,
      // porque um mês com uma despesa única não muda a meta dos outros.
      const hoje = new Date()
      const fixo = (movs || []).reduce((soma, m) => {
        if (!m.activo || !m.conta_no_lucro || m.tipo !== 'saida') return soma
        if (m.ate && new Date(m.ate) < hoje) return soma
        const v = Number(m.valor || 0)
        if (m.recorrencia === 'mensal') return soma + v
        if (m.recorrencia === 'anual') return soma + v / 12
        return soma
      }, 0)
      setCustoFixo(fixo)

      const internos = new Set((perfis || []).filter(p => p.cliente_interno).map(p => p.id))
      const encPorId = new Map((encs || []).map(e => [e.id, e]))

      // UMA ENCOMENDA PODE ESTAR REPARTIDA POR DUAS FACTURAS.
      //
      // Hoje (30/09/2026) nenhuma esta — as 32 estao cada uma na sua. Mas o
      // fornecedor ja mandou encomendas aos bocados, e no dia em que uma se
      // repartir, somar a receita inteira as duas facturas duplicava-a e o
      // lucro do mes aparecia inflacionado sem nada a assinalar. Um erro que so
      // nasce no dia em que a coisa acontece e o pior tipo de erro.
      //
      // Reparte-se pelas unidades alocadas a cada factura.
      const unPorEncomenda = new Map()
      for (const l of (links || [])) {
        unPorEncomenda.set(l.encomenda_id, (unPorEncomenda.get(l.encomenda_id) || 0) + Number(l.quantidade_alocada || 0))
      }

      const porCompra = new Map()
      for (const l of (links || [])) {
        const e = encPorId.get(l.encomenda_id)
        if (!e) continue
        const a = porCompra.get(l.compra_id) || { receitaB2B: 0, un: 0, custoInterno: 0 }
        const un = Number(l.quantidade_alocada || 0)
        if (internos.has(e.cliente_id)) {
          a.custoInterno += un * Number(l.custo_unitario_final ?? l.custo_unitario_previsao ?? 0)
        } else {
          a.un += un
          const total = unPorEncomenda.get(l.encomenda_id) || 0
          const fatia = total > 0 ? un / total : 1
          a.receitaB2B += (Number(e.total_sem_iva || 0) - Number(e.desconto_valor || 0)) * fatia
        }
        porCompra.set(l.compra_id, a)
      }

      const porMes = new Map()
      for (const c of (compras || [])) {
        if (!c.data_fatura) continue
        const a = porCompra.get(c.id)
        if (!a) continue
        const custo = Number(c.valor_final_sem_iva ?? c.valor_sem_iva ?? 0)
        const receitaB2B = a.receitaB2B
        const ym = String(c.data_fatura).slice(0, 7)
        const m = porMes.get(ym) || { ym, receita: 0, lucro: 0, un: 0, facturas: 0 }
        m.receita += receitaB2B
        m.lucro += receitaB2B + a.custoInterno - custo
        m.un += a.un
        m.facturas += 1
        porMes.set(ym, m)
      }
      setMeses([...porMes.values()].sort((a, b) => a.ym < b.ym ? 1 : -1).slice(0, 7))

      // O que está vendido e ainda não tem factura de fornecedor — não conta no
      // mês, mas responde a "estou mal ou está só por facturar?".
      const comFactura = new Set((links || []).map(l => l.encomenda_id))
      const abertas = (encs || []).filter(e =>
        !comFactura.has(e.id) && !internos.has(e.cliente_id) &&
        !['cancelada', 'cancelado', 'rejeitada'].includes(String(e.estado || '')))
      setPorFacturar({
        n: abertas.length,
        valor: abertas.reduce((s, e) => s + Number(e.total_sem_iva || 0) - Number(e.desconto_valor || 0), 0),
      })
    } catch (e) {
      setErro('Não consegui calcular o objectivo: ' + (e?.message || String(e)))
    } finally { setLoading(false) }
  }
  useEffect(() => { carregar() }, [])

  const ymAgora = new Date().toISOString().slice(0, 7)
  const mesAgora = meses.find(m => m.ym === ymAgora) || { ym: ymAgora, receita: 0, lucro: 0, un: 0, facturas: 0 }

  // O lucro por unidade vem dos meses FECHADOS, não do mês em curso: a meio do
  // mês uma factura pequena dava um valor por unidade sem sentido, e era esse
  // que ia dizer quantos perfumes faltam.
  const referencia = useMemo(() => {
    const fechados = meses.filter(m => m.ym !== ymAgora).slice(0, 6)
    const un = fechados.reduce((s, m) => s + m.un, 0)
    const lucro = fechados.reduce((s, m) => s + m.lucro, 0)
    const receita = fechados.reduce((s, m) => s + m.receita, 0)
    return {
      lucroUn: un > 0 ? lucro / un : null,
      margem: receita > 0 ? lucro / receita : null,
      meses: fechados.length,
    }
  }, [meses, ymAgora])

  const precisa = objectivo + custoFixo
  const falta = Math.max(0, precisa - mesAgora.lucro)
  const pct = precisa > 0 ? Math.min(100, Math.round(mesAgora.lucro / precisa * 100)) : 0
  const faltamUn = referencia.lucroUn ? Math.ceil(falta / referencia.lucroUn) : null
  const faltamEur = referencia.margem ? falta / referencia.margem : null
  const lucroPreso = referencia.margem ? porFacturar.valor * referencia.margem : 0

  const rotulo = { fontSize: '10px', color: C.textMuted, textTransform: 'uppercase', letterSpacing: '0.5px', fontWeight: 700 }

  if (loading) return (
    <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '18px', marginBottom: '18px', fontSize: 13, color: C.textMuted }}>
      A calcular o objectivo…
    </div>
  )

  return (
    <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: '6px', padding: '16px 18px', marginBottom: '18px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <Target size={16} color={C.accent} />
        <h2 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: C.text }}>Objectivo B2B — {eur(objectivo)} limpos por mês</h2>
        <span style={{ fontSize: 11.5, color: C.textMuted }}>{mesLegivel(mesAgora.ym)}</span>
        <button onClick={carregar} title="Recalcular"
          style={{ marginLeft: 'auto', border: `1px solid ${C.border}`, background: C.surface, borderRadius: 4, cursor: 'pointer', padding: '4px 8px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 5 }}>
          <RefreshCw size={12} /> Actualizar
        </button>
      </div>

      {erro && <div style={{ background: C.dangerSoft, border: `1px solid ${C.danger}`, color: C.danger, padding: '8px 12px', borderRadius: 4, fontSize: 12.5, marginBottom: 10 }}>{erro}</div>}

      <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
        <div style={{ fontSize: 30, fontWeight: 800, color: falta === 0 ? C.success : C.text, fontFamily: 'monospace' }}>{eur(mesAgora.lucro)}</div>
        <div style={{ fontSize: 13, color: C.textMuted }}>de {eur(precisa)} <span style={{ fontSize: 11 }}>(objectivo + {eur(custoFixo)} de custos fixos)</span></div>
      </div>

      <div style={{ height: 8, background: C.bg, borderRadius: 4, overflow: 'hidden', margin: '10px 0 6px' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: pct >= 100 ? C.success : pct >= 60 ? '#d97706' : C.danger, transition: 'width .3s' }} />
      </div>

      <div style={{ fontSize: 13.5, color: C.text, marginBottom: 14 }}>
        {falta === 0
          ? <strong style={{ color: C.success }}>Objectivo cumprido este mês.</strong>
          : <>Faltam <strong>{eur(falta)}</strong>
              {faltamUn != null && <> — cerca de <strong>{faltamUn} perfumes</strong></>}
              {faltamEur != null && <> ({eur(faltamEur)} de vendas sem IVA)</>}.</>}
        {/* UM MES VAZIO POR ESPERA NAO E UM MES MAU.
            Com o fornecedor atrasado (Set/Out de 2026) ha meses em que o
            trabalho ja esta feito e so falta a mercadoria chegar. Sem esta
            frase a barra vermelha lia-se como "estas a vender mal", e a
            decisao que sai dai — baixar precos, forcar vendas — e a errada. */}
        {falta > 0 && lucroPreso >= falta && (
          <div style={{ marginTop: 6, fontSize: 12.5, color: C.success }}>
            Já está vendido o suficiente para cobrir: <strong>{eur(lucroPreso)}</strong> de lucro à espera da factura do fornecedor.
            O mês fecha quando a mercadoria chegar, não quando se vender mais.
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: 10, marginBottom: 14 }}>
        {[
          ['Receita do mês', eur(mesAgora.receita)],
          ['Unidades', String(mesAgora.un)],
          ['Facturas fechadas', String(mesAgora.facturas)],
          ['Lucro por unidade', referencia.lucroUn ? eur(referencia.lucroUn) : '—'],
          ['Margem de referência', referencia.margem ? (referencia.margem * 100).toFixed(1) + ' %' : '—'],
        ].map(([k, v]) => (
          <div key={k} style={{ background: C.bg, borderRadius: 4, padding: '8px 10px' }}>
            <div style={rotulo}>{k}</div>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.text, fontFamily: 'monospace' }}>{v}</div>
          </div>
        ))}
      </div>

      {/* O RITMO DAS FACTURAS É O QUE FALHA, NÃO O VOLUME.
          Junho deu 994 € por uma razão só: fechou uma factura. Maio, Julho e
          Agosto fecharam duas ou três. Por isso a coluna das facturas está na
          tabela ao lado do lucro — é ela que explica os meses maus. */}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
        <thead><tr style={{ background: C.bg }}>
          {['Mês', 'Receita', 'Un', 'Fact.', 'Lucro', 'Margem'].map((h, i) => (
            <th key={h} style={{ padding: '6px 8px', textAlign: i === 0 ? 'left' : 'right', ...rotulo }}>{h}</th>
          ))}
        </tr></thead>
        <tbody>
          {meses.map(m => {
            const atingiu = m.lucro >= precisa
            return (
              <tr key={m.ym} style={{ borderTop: `1px solid ${C.border}`, background: m.ym === ymAgora ? C.bg : 'transparent' }}>
                <td style={{ padding: '6px 8px', fontWeight: m.ym === ymAgora ? 700 : 400 }}>{mesLegivel(m.ym)}</td>
                <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{eur(m.receita)}</td>
                <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{m.un}</td>
                <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace', color: m.facturas <= 1 ? C.danger : C.textMuted }}>{m.facturas}</td>
                <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 700, color: atingiu ? C.success : C.text }}>{eur(m.lucro)}</td>
                <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace', color: C.textMuted }}>{m.receita > 0 ? (m.lucro / m.receita * 100).toFixed(1) + ' %' : '—'}</td>
              </tr>
            )
          })}
        </tbody>
      </table>

      {porFacturar.n > 0 && (
        <div style={{ marginTop: 10, fontSize: 12, color: C.textMuted, lineHeight: 1.6 }}>
          <strong style={{ color: C.text }}>{eur(porFacturar.valor)}</strong> em {porFacturar.n} encomendas já vendidas e ainda <strong>sem factura de fornecedor</strong>.
          Não entram no mês porque têm receita e ainda não têm custo — a margem delas aparece no mês em que a factura fechar
          {referencia.margem && <> (à margem actual, cerca de <strong>{eur(porFacturar.valor * referencia.margem)}</strong> de lucro por reconhecer)</>}.
        </div>
      )}

      <div style={{ marginTop: 8, fontSize: 11, color: C.textFaint, lineHeight: 1.6 }}>
        Receita já com o desconto de cada cliente abatido. Lucro = receita menos a factura do fornecedor, a mesma conta do ecrã de Lucro Real.
        O lucro por unidade vem dos {referencia.meses} meses fechados, não do mês em curso.
      </div>
    </div>
  )
}
